import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/core/course.service';
import { LearnsetService } from 'src/app/core/learnset.service';
import { UserService } from 'src/app/core/user.service';
import { Course } from 'src/app/models/course.model';
import { Flashcard } from 'src/app/models/flashcard.model';
import { Learnset } from 'src/app/models/learnset.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-smart-repetition',
  templateUrl: './smart-repetition.component.html',
  styleUrls: ['./smart-repetition.component.scss'],
  standalone: false
})
export class SmartRepetitionComponent {
  
  learnsetsWithOpenCards?: Learnset[];
  user?: User;
  username?: string;

  cards: Flashcard[] = [];
  currentIndex: number = 0;
  side: 'front' | 'back' = 'front';
  openCards: number = 0;

  greetingTitle?: string;
  greetingMessage?: string;

  isLoading: boolean = true;
  showStreakDialog: boolean = false;

  courses: Course[] | undefined;

  totalSmartRepetitionCards?: number;

  constructor(
    private learnsetService: LearnsetService,
    private userService: UserService,
    private router: Router,
    private courseService: CourseService,
  ) {}

  ngOnInit(): void {
    this.userService.getUser().subscribe((user) => {
      this.user = user;
      this.username = user?.firstName ? user.firstName : '';
      this.setGreeting();
    });
    this.learnsetService.getAllWithOpenCards().subscribe((learnsets) => {
      this.learnsetsWithOpenCards = learnsets;
      for (let i = 0; i < this.learnsetsWithOpenCards.length; i++) {
        this.openCards = this.openCards + this.learnsetsWithOpenCards[i].openCards!;
      }
      this.isLoading = false;
    });
    this.courseService.getSmartRepetitionCourses().subscribe((courses) => {
      this.courses = courses;
    });
    this.userService.fetchRepeatCardsCount();
  }

  setGreeting() {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 5 && hours < 12) {
      this.greetingTitle = `Guten Morgen ${this.username}! 👋`;
      this.greetingMessage = "Bereit für einen produktiven Tag? 💪";
    } else if (hours >= 12 && hours < 17) {
      this.greetingTitle = `Hey ${this.username}! 👋`;
      this.greetingMessage = "Wir hoffen, dein Tag läuft gut! 🌞";
    } else if (hours >= 18 && hours < 22) {
      this.greetingTitle = `Guten Abend ${this.username}! 👋`;
      this.greetingMessage = "Zeit, die letzten Aufgaben zu erledigen! 🌇";
    } else {
      this.greetingTitle = `Hey ${this.username}! 🌙`;
      this.greetingMessage = "Bleib motiviert, aber gönn dir auch eine Pause! 🌙";
    }
  }

  handleLearnsetClick(learnset: Learnset) {
    this.router.navigate([`/sets/${learnset.id}`]);
  }

  startSession() {
    this.router.navigate([`sets/${this.learnsetsWithOpenCards![0].id}/learn`], { queryParams: { smartRepetition: true } });
  }

  showStreak() {
    this.showStreakDialog = true;
  }
}
